"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaDialogue = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactAddSpace = _interopRequireDefault(require("react-add-space"));

var _reactBootstrap = require("react-bootstrap");

var _Modal = _interopRequireDefault(require("react-bootstrap/Modal"));

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utilitaires = require("../utils/utilitaires.js");

require("../css/mfa-dialogue.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaDialogue = /*#__PURE__*/function (_Component) {
  _inherits(MfaDialogue, _Component);

  var _super = _createSuper(MfaDialogue);

  function MfaDialogue(props) {
    _classCallCheck(this, MfaDialogue);

    return _super.call(this, props);
  }

  _createClass(MfaDialogue, [{
    key: "obtenirMessageBoutonAnnulation",
    value: function obtenirMessageBoutonAnnulation() {
      var messageboutonAnnulation = this.props.messageboutonAnnulation;
      return (0, _utilitaires.estDefini)(messageboutonAnnulation) ? messageboutonAnnulation : 'Annuler';
    }
  }, {
    key: "obtenirMessageBoutonSortie",
    value: function obtenirMessageBoutonSortie() {
      var messageboutonSortie = this.props.messageboutonSortie;
      return (0, _utilitaires.estDefini)(messageboutonSortie) ? messageboutonSortie : 'OK';
    }
  }, {
    key: "obtenirCouleurIcone",
    value: function obtenirCouleurIcone(couleurIcone) {
      var couleur = 'blue';

      if ((0, _utilitaires.nestPasNulOuVide)(couleurIcone)) {
        couleur = couleurIcone;
      }

      return couleur;
    }
  }, {
    key: "obtenirTailleIcone",
    value: function obtenirTailleIcone() {
      var tailleIcone = 'large';

      if ((0, _utilitaires.nestPasNulOuVide)(this.props.tailleIcone)) {
        if (this.props.tailleIcone === 'xxl') {
          tailleIcone = 'huge';
        } else if (this.props.tailleIcone === 'xl') {
          tailleIcone = 'big';
        }
      }

      return tailleIcone;
    }
  }, {
    key: "render",
    value: function render() {
      var proprietes = this.obtenirPropsFiltrees();
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Modal.default, _extends({
        className: "mfa-dialogue"
      }, proprietes, {
        show: this.props.estVisible,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true
      }), this.props.cacherEntete !== true ? /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
        className: "mfa-section-titre-cache",
        closeButton: (0, _utilitaires.estDefini)(this.props.surAnnulation) ? true : false,
        onHide: this.props.surAnnulation
      }, /*#__PURE__*/_react.default.createElement(_Modal.default.Title, {
        id: "contained-modal-title-vcenter"
      }, (0, _utilitaires.nestPasNulOuVide)(this.props.nomIconeTitre) && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        color: this.obtenirCouleurIcone(this.props.couleurIconeTitre),
        name: this.props.nomIconeTitre
      }), this.props.titre)) : null, /*#__PURE__*/_react.default.createElement(_Modal.default.Body, null, (0, _utilitaires.nestPasNulOuVide)(this.props.nomIcone) && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        color: this.obtenirCouleurIcone(this.props.couleurIcone),
        name: this.props.nomIcone,
        size: this.obtenirTailleIcone()
      }), this.props.message, this.props.children), /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, null, (0, _utilitaires.nestPasNulOuVide)(this.props.surAnnulation) && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
        variant: "secondary",
        className: this.obtenirClasseBoutonAnnuler(),
        onClick: this.props.surAnnulation
      }, this.obtenirMessageBoutonAnnulation(), " "), (0, _utilitaires.nestPasNulOuVide)(this.props.surAnnulation) && /*#__PURE__*/_react.default.createElement(_reactAddSpace.default, {
        amount: 5
      }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
        variant: "primary",
        disabled: this.desactiverBoutonSortir(),
        className: "principal",
        onClick: this.props.surSortie
      }, this.obtenirMessageBoutonSortie()))));
    }
  }, {
    key: "desactiverBoutonSortir",
    value: function desactiverBoutonSortir() {
      if ((0, _utilitaires.estDefini)(this.props.desactiverBoutonSortir) && this.props.desactiverBoutonSortir === true) {
        return true;
      }

      return false;
    }
  }, {
    key: "obtenirClasseBoutonAnnuler",
    value: function obtenirClasseBoutonAnnuler() {
      var nomClasse = "secondaire ";

      if ((0, _utilitaires.estDefini)(this.props.afficherBoutonAnnulerExtremeGauche) && this.props.afficherBoutonAnnulerExtremeGauche === true) {
        nomClasse += " mr-auto";
      }

      return nomClasse;
    }
  }, {
    key: "obtenirPropsFiltrees",
    value: function obtenirPropsFiltrees() {
      return (0, _utilitaires.filtrerProprietesObjet)(this.props, ['afficherBoutonAnnulerExtremeGauche', 'cacherEntete', 'couleurIcone', 'couleurIconeTitre', 'desactiverBoutonSortir', 'estVisible', 'message', 'messageboutonAnnulation', 'messageboutonSortie', 'nomIcone', 'nomIconeTitre', 'surAnnulation', 'surSortie', 'tailleIcone', 'titre']);
    }
  }]);

  return MfaDialogue;
}(_react.Component);

exports.MfaDialogue = MfaDialogue;

_defineProperty(MfaDialogue, "defaultProps", {
  desactiverBoutonSortir: false,
  afficherBoutonAnnulerExtremeGauche: false
});

_defineProperty(MfaDialogue, "proptypes", {
  desactiverBoutonSortir: _propTypes.default.bool,
  afficherBoutonAnnulerExtremeGauche: _propTypes.default.bool
});